<div class="poll-title">
    {{data.title}}
</div> 
<div class="bar-vert-chart">
  <ngx-charts-bar-vertical
    [scheme]="colorScheme"
    [results]="data.answers"
    [barPadding]="150"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend">
  </ngx-charts-bar-vertical>
</div>